import LegalPage from "@/components/legal/LegalPage";
import { legalPolicies } from "@/src/content/legalPolicies";

export default function TermsPage() {
  return <LegalPage policy={legalPolicies.terms} />;
}
